import axios from 'axios';
import { notification } from 'antd';
import { API_BASE_URL } from './config/constants';

// Create an Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('idToken')}`,
  },
});

// Response interceptor for handling responses globally
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      notification.error({
        message: 'Unauthorized',
        duration: 4.5,
      });
    } 

    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: 'Permission is denied',
        duration: 4.5,
      });
    }
    return Promise.reject(error);
  }
);

export default api;
